import { Pipe, PipeTransform } from '@angular/core';
import { format, formatRelative } from 'date-fns';
import { ru } from 'date-fns/locale';

@Pipe({ name: 'dt' })
export class DtPipe implements PipeTransform {

    transform(value: number | string | Date | undefined, abs = true, retStr = '-', fmt = 'dd.MM.y HH:mm:ss', emptySrt = ''): string {
        if (!value) {
            return retStr;
        }
        if (typeof value != 'object') {
            value = new Date(typeof value == 'number' ? value * 1000 : new Date(value || ''));
        }
        return abs
            ? (value && !isNaN(value.getTime()) ? format(value, fmt, { locale: ru }) : emptySrt)
            : (value && !isNaN(value.getTime()) ? formatRelative(value, new Date(), { locale: ru }) : emptySrt);
    }

}
